import { Injectable } from '@angular/core';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { CompanyProfileServiceProxy, ProjectTeamGetAllDto } from '@shared/service-proxies/service-proxies';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
 //public passData = new Subject();
  //public passDataEvent = this.passData.asObservable();
  navFromDetailpageObs = new Subject<void>();
  navigatedFromDatailPage : boolean;

 // indexNo: any;

  nameArray: any;
  
  getCardList() {
    return this.nameArray;
  }

  createCard(data: any) {
    if (data.length !== 0) this.nameArray = data;
  }

  
  constructor(private _companyProfileServiceProxy: CompanyProfileServiceProxy, private _usersDateFormatService: UsersDateFormatService) { }

  getFullname(name: string, lastname: string) {
    return name + " " + lastname;
  }

  showTooltip(name:string, num:number){
    return name.length > num ? true : false;
  }
  
  selectedIndexTab: any;
  setHelpCardData(index: any){
    return index
  }

  projectType: number;
  setProjectId(type: number)
  {
    this.projectType = type;
  }
  getProjectid()
  {
    return this.projectType;
  }

  // getTabIndexData(){
    
    
  // }
  
  // setData(index:any){
  //  this.passData.next(index);
  // }


}
